const InviteInternalUser = () => import("../components/inviteInternalUser.vue");
const ManageUsers = () => import("../components/manageUsers.vue");
const InviteClientUser = () => import("../components/inviteClientUser.vue");
const UserView = () => import("../components/userView.vue");
 
export default [
  // Aucera admin screens
  {
    name: "users.view",
    path: "/admin/users/view",
    meta: {
      Title: "All Users",
      layout: "LoggedLayout",
      requireAuth: true,
      requireAuceraUser: true,
    },
    component: UserView,
  },
  {
    name: "users.inviteAucera",
    path: "/admin/users/invite",
    meta: {
      Title: "Invite Aucera User",
      layout: "LoggedLayout",
      requireAuth: true,
      requireAuceraUser: true,
    },
    component: InviteInternalUser,
  },
  {
    name: "users.manage",
    path: "/admin/users/manage",
    meta: {
      Title: "Manage Users",
      layout: "LoggedLayout",
      requireAuth: true,
      requireAuceraUser: true,
    },
    component: ManageUsers,
  },
 
  // Client admin/support screen
  {
    name: "client.users.invite",
    path: "/client/users/invite",
    meta: {
      Title: "Invite Client User",
      layout: "LoggedLayout",
      requireAuth: true, // no Aucera requirement here
    },
    component: InviteClientUser,
  },
  {
    name: "client.users.view",
    path: "/client/users/view",
    meta: {
      Title: "Client Users",
      layout: "LoggedLayout",
      requireAuth: true,
    },
    component: UserView,
}
];